export default {
  webBaseURL: process.env.VUE_APP_MIX_APP_URL,
};
